<template>
    <div
        class="rp-helpcenter-code-form-suggestion"
        :style="{ margin: marginForLabel}"
        >
        <div
            class="rp-helpcenter-code-form-suggestion__text"
            :color="'#666666'">
            {{ suggestionText }}
        </div>
        &nbsp;
        <el-button
            type="text"
            @click="$emit('click')"
            :disabled="ctaDisabled"
            >
            {{ ctaText }}
        </el-button>
    </div>
</template>
<script>
export default {
    props: {
        suggestionText: String,
        ctaText: String,
        marginForLabel: String,
        ctaDisabled: {
            type: Boolean,
            default: false,
        }
    }
    
}
</script>
<style lang="scss" scoped>
.rp-helpcenter-code-form-suggestion {
    display: flex;
    align-items: center;
    white-space: nowrap;
    .rp-helpcenter-code-form-suggestion__text{
        font-size: 14px;
        color: #666666;
        font-weight: 300;
        cursor: inherit;
        @include for-size(desktop-up){
            font-size: 16px;
        }
    }
    button {
        color: var(--theme-color) !important;
        &:disabled {
            color: #4d4d4d !important;
        }
        @include for-size(desktop-up){
            font-size: 16px;
        }
    }
}
</style>